<template xmlns="http://www.w3.org/1999/html">
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'company.assignments.list' }">
                {{ $t('general.assignments') }}
              </router-link>
            </li>
            <li>{{ $t('general.edit_assignment') }}</li>
          </ul>
        </nav>
      </div>
      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left"><span>{{ $t('general.edit_assignment') }}</span></h2>
        </div>
      </div>
      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <ul id="main-switcher" class="uk-child-width-expand uk-tab stepper-buttons"
          uk-switcher="connect: #main-switcher-tabs ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
          <li class="uk-active">
            <a class="p-4" href="#"><i class="uil-invoice"></i> <b> {{ $t('general.overview') }}</b></a>
          </li>
        </ul>

        <default-loading v-if="assignment_loading || !formattedAssignmentItem"></default-loading>
        <template v-else>
          <div v-if="item_loaded" class="card-body">
            <ul id="main-switcher-tabs" class="uk-switcher uk-margin">
              <li>
                <div class="row">
                  <div class="col-12">
                    <div class="text-center">
                      <div class="col-md-6 offset-md-3">
                        <table class="uk-table uk-table-divider result-table">
                          <tbody>
                            <tr>
                              <td class="text-center" colspan="2">
                                <img :src="cover_image_link ? cover_image_link : '@/assets/images/no-photo.png'" alt=""
                                  class="logoarea rounded img-fluid" />
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right"> {{ $t('general.assignment_name') }}</td>
                              <td class="text-left">
                                <b>{{ name }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">
                                {{ this.$t('general.number_of_assigned_users') }}:
                              </td>
                              <td class="text-left">
                                <b>{{ checked_users.length }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">{{ this.$t('general.give_a_gift_at_the_end') }}:</td>
                              <td class="text-left">
                                <b>{{ assignment_item.has_present ? $t("general.yes") : $t("general.no") }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">
                                {{ this.$t('general.top_rankings_list_display') }}:
                              </td>
                              <td class="text-left">
                                <b>{{ appear_top ? $t("general.yes") : $t("general.no") }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">{{ this.$t('general.start_day') }}:</td>
                              <td class="text-left">
                                <b>{{ start_date }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right"> {{ $t('general.final_completion_date') }}</td>
                              <td class="text-left">
                                <b>{{ end_date }}</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- QR alanı: grid dışında, tam genişlikte ve ortalı -->
                      <div v-if="qrCodeCanBeShown" class="qr-section">
                        <div class="qr-grid">
                          <div v-for="(item, qrIndex) in qr_text_array" :key="qrIndex" class="qr-card">
                            <div class="qr-card-header">
                              <h4 class="qr-card-title">{{ item.title }}</h4>
                            </div>
                            <div class="qr-card-body">
                              <QrCodeStyled :data="item.code" :download-file-name="item.title || 'qr-code'"
                                :download-size="1000" :margin="12" :show-download="true" :size="200"
                                background-color="#ffffff" corners-dot-color="#0c4a6e" corners-dot-type="dot"
                                corners-square-color="#0c4a6e" corners-square-type="extra-rounded" dots-color="#1e3a5f"
                                dots-type="rounded" error-correction-level="H" />
                            </div>
                            <div class="qr-card-info">
                              <div v-if="item.pivot && item.pivot.starts_at" class="qr-date">
                                <i class="uil-calendar-alt"></i>
                                <span>{{
                                  $t('general.start_date')
                                }}: {{ moment(item.pivot.starts_at).format("DD/MM/YYYY HH:mm") }}</span>
                              </div>
                              <div v-if="item.pivot && item.pivot.ends_at" class="qr-date">
                                <i class="uil-clock"></i>
                                <span>{{
                                  $t('general.end_date')
                                }}: {{ moment(item.pivot.ends_at).format("DD/MM/YYYY HH:mm") }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mt-4">
                      <button class="btn btn-primary" type="button" @click="openCompleteModal()">
                        <i class="uil-check-circle"></i> {{ $t('general.complete_assignment') }}
                      </button>
                    </div>

                  </div>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>

    <!-- Tamamlandıya Çek Modal -->
    <AppModal :close-on-overlay="false" :visible.sync="showCompleteModal" :title="$t('general.mark_as_completed')" width="90%"
      max-height="90vh">
      <div class="row position-relative">
        <UserGroupSelection :assignment_id="Number($route.params.id)" :checked_users="complete_checked_users"
          :is-groups-active="true" :is-user-list-included="true" :not-assignment-completed="true"
          @setCheckedUsers="($event) => { complete_checked_users = $event }"
          @setCheckedGroups="($event) => { complete_checked_groups = $event }" />
      </div>
      <template #footer>
        <div class="complete-modal-footer">
          <div class="complete-modal-inputs">
            <div class="complete-modal-field">
              <div class="complete-modal-label"> {{ $t('general.assignment_complete_date') }}</div>
              <VueCtkDateTimePicker v-model="complete_completed_at" :format="'YYYY-MM-DD HH:mm:ss'" />
            </div>
            <div class="complete-modal-field">
              <div class="complete-modal-label">
                {{ $t('general.complete_date_min') }}
                <i :uk-tooltip="'title: ' + $t('general.complete_date_desc') + '; pos: top-center'"
                  class="uil-info-circle ml-1" />
              </div>
              <input v-model.number="complete_duration" class="uk-input complete-modal-input" min="0"
                :placeholder="$t('general.eg_30')" type="number" />
            </div>
          </div>
          <div class="complete-modal-actions">
            <button class="uk-button uk-button-default" type="button" @click="showCompleteModal = false">
              <i class="uil-times"></i> {{ $t("general.close") }}
            </button>
            <button class="uk-button uk-button-primary" type="button" @click="saveCompleteUsers">
              <i class="uil-check"></i> {{ $t('general.save_and_close') }}
            </button>
          </div>
        </div>
      </template>
    </AppModal>

  </div>
</template>

<script>
import store from "@/core/services";
import UserGroupSelection from "@/view/components/assignment/UserGroupSelection";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import AppModal from "@/view/components/ui/AppModal";

import assignment_module, {
  BASE_URL as ASSIGNMENT_BASE_URL,
  GET_ITEM as ASSIGNMENT_GET_ITEM,
  ITEM as ASSIGNMENT_ITEM,
  LOADING as ASSIGNMENT_LOADING,
  MODULE_NAME as ASSIGNMENT_MODULE_NAME,
} from "@/core/services/store/assignment.module";

import QrCodeStyled from "@/view/components/ui/QrCodeStyled.vue";
import { createQrCodeForEveryClassroomEducation } from "@/view/company/Assignments/helpers/qrCodeHelper";
import moment from "moment/moment";
import axios from "axios";
import { showError, showSuccess } from "@/utils/alertUtils";
import { convertUTCToLocal } from "@/utils/timeUtils";

const _ASSIGNMENT_MODULE = ASSIGNMENT_MODULE_NAME;

export default {
  name: "AssignmentPreview",
  components: {
    UserGroupSelection,
    DefaultLoading,
    QrCodeStyled,
    AppModal
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_ASSIGNMENT_MODULE, assignment_module);
  },
  data() {
    return {
      qrCodeCanBeShown: false,
      successMessage: null,
      errorMessages: [],
      cover_image_link: null,
      checked_users: [],
      name: null,
      start_date: null,
      end_date: null,
      appear_top: false,
      item_loaded: false,
      qr_text_array: [],
      complete_checked_users: [],
      complete_checked_groups: [],
      complete_completed_at: null,
      complete_duration: null,
      showCompleteModal: false,
    };
  },
  computed: {
    moment() {
      return moment
    },
    assignment_item: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ITEM];
      },
      set(value) {
      },
    },
    assignment_loading: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_LOADING];
      },
      set(value) {
      },
    },
    formattedAssignmentItem() {
      const item = this.assignment_item;

      this.item_loaded = false;
      if (item == null || item.users == undefined) return false;
      this.checked_users = item.users;
      this.name = item.name;
      // Backend'den UTC olarak gelen tarihleri local saate çevir
      this.start_date = convertUTCToLocal(item.start_date);
      this.end_date = convertUTCToLocal(item.end_date);
      this.appear_top = item.appear_top;
      this.cover_image_link = item.cover_image_link;
      this.item_loaded = true;
      return true;
    },
  },
  methods: {
    openCompleteModal() {
      this.complete_checked_users = [];
      this.complete_checked_groups = [];
      this.complete_completed_at = moment().format("YYYY-MM-DD HH:mm:ss");
      this.complete_duration = null;
      this.showCompleteModal = true;
    },
    saveCompleteUsers() {
      const hasUsers = this.complete_checked_users && this.complete_checked_users.length > 0;
      const groupIds = Array.isArray(this.complete_checked_groups)
        ? this.complete_checked_groups
        : (this.complete_checked_groups?.ids || []);
      const hasGroups = groupIds.length > 0;

      if (!hasUsers && !hasGroups) {
        showError(this.$t('general.please_select_user_or_group'));
        return;
      }

      const assignmentId = this.$route.params.id;
      const completedAt = moment(this.complete_completed_at)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");

      const duration = this.complete_duration !== null && this.complete_duration !== '' ? this.complete_duration : null;

      const payload = {
        user_ids: this.complete_checked_users || [],
        group_ids: groupIds,
        completed_at: completedAt,
        duration: duration
      };

      axios.put(`${ASSIGNMENT_BASE_URL}/bulk-complete/${assignmentId}`, payload)
        .then(() => {
          this.scrollToTop();
          // this.successMessage = "Seçilen kullanıcılar tamamlandıya çekildi.";
          showSuccess(this.$t('general.selected_users_marked_completed'));
          this.showCompleteModal = false;
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.message || error.message || this.$t('general.error_occurred');
          showError(errorMessage);
          // this.errorMessages.push(errorMessage);
          // this.showCompleteModal = false;
          // this.scrollToTop();
        });
    },
    getAssignmentItem() {
      this.$store.dispatch(ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_GET_ITEM, {
        url: ASSIGNMENT_BASE_URL + "/" + this.$route.params.id,
      }).then((response) => {
        this.qr_text_array = createQrCodeForEveryClassroomEducation({
          result: response,
          assignmentId: this.$route.params.id
        });
        if (this.qr_text_array?.length) {
          this.qrCodeCanBeShown = true;
        }
      });
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    this.getAssignmentItem();
  },
  watch: {
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
  },
  created() {
    this.debouncedResetValues = _.debounce(this.resetMessages, 3000);
  },
};
</script>
<style scoped>
.complete-modal-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.complete-modal-inputs {
  display: flex;
  align-items: flex-end;
  gap: 16px;
}

.complete-modal-field {
  display: flex;
  flex-direction: column;
}

.complete-modal-label {
  margin-bottom: 4px;
  min-height: 20px;
}

.complete-modal-field>>>.date-time-picker,
.complete-modal-field>>>.date-time-picker * {
  margin: 0 !important;
}

.complete-modal-field>>>.date-time-picker .datetimepicker {
  z-index: 9999 !important;
}

.complete-modal-field>>>.date-time-picker .field-input {
  height: 42px !important;
  min-height: 42px !important;
}

.complete-modal-input {
  height: 42px;
  margin: 0;
}

.complete-modal-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* QR alanı: masaüstünde her satırda 2 kart, ortalı */
.qr-section {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
  width: 100%;
  display: flex;
  justify-content: center;
}

.qr-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  max-width: 720px;
  /* 2 kart + aralık için yaklaşık genişlik */
  margin: 0 auto;
}

.qr-card {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 1.25rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  max-width: 320px;
  width: 100%;
  flex: 0 1 calc(50% - 0.75rem);
  /* satırda en fazla 2 kart */
}

@media (max-width: 768px) {
  .qr-grid {
    max-width: 100%;
  }

  .qr-card {
    flex: 0 1 100%;
    max-width: 100%;
  }
}

.qr-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(14, 165, 233, 0.15);
}

.qr-card-header {
  text-align: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.qr-card-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
}

.qr-card-body {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
}

.qr-card-info {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  margin-bottom: -1.25rem;
  padding: 1rem 1.25rem;
  border-radius: 0 0 20px 20px;
}

.qr-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #64748b;
  margin-bottom: 0.375rem;
}

.qr-date i {
  color: #0ea5e9;
  font-size: 1rem;
}

.qr-date span {
  font-weight: 500;
}
</style>
